export default class Tool {
  constructor(id, key, name, description, category, unlockDate, state) {
    this.id = id
    this.key = key
    this.name = name
    this.description = description
    this.category = category
    this.unlockDate = unlockDate || null
    this.state = state || null
    this.icon = this.getIcon(key)
  }

  // From the `ToolKitState(Enum)` class in the backend service.
  static STATE_WORKS = 1
  static STATE_DOESNT = 2
  static STATE_CANT = 3

  // TODO: Add images instead of icons.
  getIcon(key) {
    switch(key) {
      // BEDTIME_ROUTINE
      case 'READ_BOOK': return '📖'
      case 'MEDITATE': return '🧘'
      case 'NO_SCREENS': return '📵'
      case 'SUNLIGHT': return '☀️'
      case 'DIM_LIGHTS': return '💡'
      case 'CLOSE_BLINDS': return '🪟'
      case 'WARM_SHOWER': return '🚿'

      // MORNING_ROUTINE
      case 'MORNING_WALK': return '🚶'
      case 'OPEN_BLINDS': return '🪟'
      case 'DRINK_WATER': return '💧'
      case 'COLD_SHOWER': return '🚿'
      case 'MORING_EXERCISE': return '🏋️'
      case 'GET_UP': return '🏃'
      case 'LIGHTS_ON': return '💡'
      case 'ALARM_OFF': return '🔕'

      // DAILY_HABITS
      case 'NO_CAFFEINE': return '☕️'
      case 'NO_ALCOHOL': return '🍺'
      case 'NAPPING': return '😴'
      case 'BIG_MEALS': return '🍕'
      case 'NO_DRUGS': return '💊'
      case 'NOON_EXERCISE': return '🏋️'
      case 'NO_WATER': return '💧'

      // SLEEPING_ENVIRONMENT
      case 'ROOM_TEMP': return '🌡️'
      case 'BED_TEMP': return '🛏️'
      case 'LIGHTS_OFF': return '💡'
      case 'EYE_MASK': return '🕶️'
      case 'SLEEP_SOUNDS': return '🔉'
      case 'EARPLUGS': return '🙉'
      case 'PILLOW': return '💆'
      case 'MATTRESS': return '🛌'
      case 'BLANKET': return '🧣'
      case 'PAJAMAS': return '👕'

      // Old.
      case 'MEDITATION': return '🧘'
      case 'NO_SCREEN_TIME_BEFORE_BED': return '📵'
      case 'GET_OUTDOOR_SUNLIGHT_BEFORE_BED': return '☀️'
      case 'REDUCE_EXTERNAL_LIGHTING': return '💡'

      // TODO: Throw error instead.
      default: return '💤'
    }
  }
}